import {Component, EventEmitter} from '@angular/core';
import {ModalComponent} from '../modal-service.service';
import {UserPreferencesService} from '../../../service/user-preferences.service';
import {UserPrefsGroup} from '../../../models/user-prefs-group.model';
import {UserPrefsCategory} from '../../../models/user-prefs-category.model';
import {UserPrefsAttrs, UserPrefsAttrsOption} from '../../../models/user-prefs-attrs.model';
import {NgClass} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NotificationAlertsService} from '../../../notification-alerts/notification-alerts.service';

@Component({
    selector: 'nlr-user-preferences-modal',
    imports: [NgClass, FormsModule],
    templateUrl: './user-preferences-modal.component.html',
    styleUrls: ['../modal.scss', './user-preferences-modal.component.scss']
})
export class UserPreferencesModalComponent implements ModalComponent {
    title = 'User Preferences';

    modalClosed: EventEmitter<string> = new EventEmitter();
    modalSize: string = 'modal-lg';
    userPrefsAttrsLookups: UserPrefsAttrs[] = [];
    userPrefsCategoryLookups: UserPrefsCategory[] = [];
    userPrefsGroupLookups: UserPrefsGroup[] = [];
    mergeLinesViewOptions: UserPrefsAttrsOption[] = undefined;
    display: boolean = false;
    mergeLinesTypeSelected: any = undefined;

    constructor(
        private userPreferencesService: UserPreferencesService,
        private notificationAlertsService: NotificationAlertsService
    ) {
        this.init();
    }

    private init() {
        this.userPrefsAttrsLookups = this.userPreferencesService.userPrefsAttrsLookups;
        this.userPrefsCategoryLookups = this.userPreferencesService.userPrefsCategoryLookups;
        this.userPrefsGroupLookups = this.userPreferencesService.userPrefsGroupLookups;
        this.mergeLinesViewOptions =
            this.userPrefsAttrsLookups && this.userPrefsAttrsLookups.length > 1 && this.userPrefsAttrsLookups[1].options
                ? JSON.parse(this.userPrefsAttrsLookups[1].options)
                : [];
        if (
            this.userPreferencesService.userPreferences &&
            this.userPreferencesService.userPreferences.undockedWindows &&
            this.userPreferencesService.userPreferences.mergeLinesDistanceCalculationMethod
        ) {
            this.display = this.userPreferencesService.userPreferences.undockedWindows.includes('CONSTRUCTION_TOOLS_WINDOW');
            this.mergeLinesTypeSelected =
                this.userPreferencesService.userPreferences.mergeLinesDistanceCalculationMethod === 'SUM_SELECTED_LINES' ? 1 : 2;
        } else if (this.userPrefsAttrsLookups && this.userPrefsAttrsLookups.length > 1) {
            this.display = this.userPrefsAttrsLookups[0].defaultValue?.toLowerCase() === 'true';
            this.mergeLinesTypeSelected = this.userPrefsAttrsLookups[1].defaultValue;
        }
    }

    clickDisplay() {
        this.display = !this.display;
    }

    closeDialog() {
        this.modalClosed.emit('Close dialog');
    }

    saveUserPreferences(options?) {
        this.userPreferencesService.saveUserPreferences(this.mergeLinesTypeSelected, this.display);
        options = options ? structuredClone(options) : {};
        options.showAlertOnSave = options.showAlertOnSave !== false;
        if (options.showAlertOnSave) {
            this.notificationAlertsService.showPreferencesSaveSuccess();
        }
        this.modalClosed.emit('Close dialog');
    }
}
